import React, {useState, useCallback} from 'react';
import {useSelector, useDispatch, shallowEqual} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toggleLinkSlider, uploadYoutubeLink, uploadImageFromLink} from '../../actions/upload-options';
import {getListingData,getProductData} from '../../actions/products';
import SliderWrapper from 'jd-library/SliderWrapper';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import Button from 'jd-library/Button';
// import {showToastMessage} from '../../actions/toastmessage';
import toastMessageActions from 'jd-library/toastMessageActions';
import styles from './link-upload-slider.scss';
import { isValidURL, isValidImageURL } from '../../utills';
import historyHandler from 'jd-library/historyHandler';

const getSliderOptions = ({uploadOptions}) => uploadOptions;
const isLibraryOpen = ({videoLibrary}) => videoLibrary.showLibrarySlider;
const getIsMobile = ({library}) => library.deviceData.isMobile;

const YOUTUBE_REGEX = /^(?:https?:\/\/)?(?:(www|m)\.)?(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

const INVALID_URL_MESSAGE = 'Invalid URL Entered';

const imageValidator = (value) => {
    if(!value) {
        return 'Please Enter Image Link';
    }
    if(!isValidURL(value)){
        return INVALID_URL_MESSAGE
    }
    if(!isValidImageURL(value)){
        return 'Please Use Image Link With JPEG, PNG, JPG or WEBP Format'
    }
    return '';
};

const videoValidator = (value, type) => {
    if(!value || !YOUTUBE_REGEX.test(value)) {
        return 'Please Enter Valid YouTube Link';
    }

    return '';
};

const data = {
    image: {
        title: 'Add Image Link',
        label: 'Image Link',
        placeHolder: 'https://',
        buttonText: 'Upload Image',
        validator: imageValidator
    },
    video: {
        title: 'Add YouTube Link',
        label: 'YouTube Link',
        placeHolder: 'https://',
        buttonText: 'Save',
        validator: videoValidator
    }
}

const LinkUploadSlider = props => {
    const showAddEditProduct = useSelector(state => state.products.showAddEditProduct);
    const showEnrichEditProduct = useSelector(state => state.products.showEnrichEditProduct);
    const selectedCategoryType = useSelector(state => state.products.selectedCategoryType);
    const showAddEditProductOmni = useSelector(state => state.products.showAddEditProductOmni);
    const deviceData = useSelector(({library}) => library.deviceData);
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const [loader, toggleLoader] = useState(false);
    const options = useSelector(getSliderOptions, shallowEqual);
    const libraryFlag = useSelector(isLibraryOpen);
    const isMobile = useSelector(getIsMobile, shallowEqual);
    const dispatch = useDispatch();
    const history = useHistory();
    const typeData = {
        ...data[options.type],
        ...options.data.view
    };
    const variantId = options && options.data ? options.data.productId : '';

    const validator = props.validator || typeData.validator;

    const onHidden = useCallback(() => {
        clearValue();
        dispatch(toggleLinkSlider({
            show: false
        }))
    }, []);

    const handleChange = useCallback(e => {
        setValue(e.target.value);
        setError('');
    }, []);

    const clearValue = useCallback(() => {
        setValue('');
        setError('')
    }, []);

    const onPasteClick = () => {
        if(window.Android && window.Android.getClipboardData){
            const text = window.Android.getClipboardData();
            if(text){
                setValue(text);
                setError('');
            }
        } else{
            navigator.clipboard.readText().then(text => {
                if(text) {
                    setValue(text);
                    setError('');
                }
            });
        }
    }

    const handleSubmit = () => {
        if(loader) {
            return;
        }
        let trimmedValue = (value || "").replace(/\s/g, "");
        const error = validator(trimmedValue, options.type);
        if(error) {
            setError(error);
            return dispatch(toastMessageActions.showMessage({
                showToastMessage: true,
                message: error,
                type: 'error',
                duration: 5000
            }));
        }

        toggleLoader(true);

        const isAddProductPage = showAddEditProduct || showAddEditProductOmni;//history.location.pathname.indexOf("/products/add") != -1
        const isEnrichProductPage = showEnrichEditProduct;

        switch(options.type){
            case 'video': {
                return dispatch(uploadYoutubeLink({
                    link: trimmedValue,
                    onFileUpload: options.onFileUpload,
                    isAddProductPage,
                    isEnrichProductPage
                }, isSuccess => {
                    if(props.source && props.source == 'b2b'){
                        let listingData = {};
                        if(props.tabKey){
                            listingData.tabKey = props.tabKey
                        }
                    }
                    toggleLoader(false);
                    if(isSuccess) {
                        history.goBack();
                        if(libraryFlag) {
                            history.goBack();
                        }
                        setTimeout(() => {
                            if((!isAddProductPage && !isEnrichProductPage) && variantId == 'ADD_PRODUCT'){
                                if(isMobile){
                                    history.push("/products/add?selectedProductType="+selectedCategoryType)
                                }else{
                                    dispatch(getProductData({
                                        productId : 'ADD_PRODUCT'
                                    }));
                                }
                            }
                        }, 100)
                    }
                }));
            }
            case 'image': {
                return dispatch(uploadImageFromLink({
                    link: trimmedValue,
                    onFileUpload: options.onFileUpload,
                    isAddProductPage: showAddEditProduct,
                    isAddProductPageOmni: showAddEditProductOmni,
                    isEnrichProductPage: showEnrichEditProduct,
                    fromViewImageSlider: options.fromViewImageSlider
                }, (isSuccess, errMsg) => {
                    toggleLoader(false);
                    if(isSuccess){
                        history.goBack();
                        setTimeout(() => {
                            if((!isAddProductPage && !isEnrichProductPage)  && variantId == 'ADD_PRODUCT'){
                                if(isMobile){
                                    history.push("/products/add?selectedProductType="+selectedCategoryType)
                                }else{
                                    dispatch(getProductData({
                                        productId : 'ADD_PRODUCT'
                                    }));
                                }
                            }
                        }, 100)
                    }else{
                        if(errMsg === "Enter valid web link"){//ask to change response pass errorCode
                            errMsg = INVALID_URL_MESSAGE
                        }
                        toggleLoader(false);
                        setError(errMsg);
                        dispatch(toastMessageActions.showMessage({
                            showToastMessage: true,
                            message: errMsg,
                            type: 'error',
                            duration: 5000
                        }));

                    }
                }))
            }
        }

        console.log('submit link', trimmedValue);
    }

    const btnPropsObj = {
        showLoader: loader,
        block: true,
        size: 'lg',
        onClick: handleSubmit,
        className: styles['submit-btn'],
        children: typeData.buttonText
    }

    return options.sliderType == 'link' && (
        <SliderWrapper
            header={{
                heading: typeData.title,
                variant: 'secondary',
                hasBorder: true,
                ...(isMobile || historyHandler.getOpenSliders().length > 1 ? {} : {
                    leftIcons: []
                })
            }}
            footer={isMobile ? null : {
                btnProps: [btnPropsObj]
            }}
            onHidden={onHidden}
        >
            <div className={styles['link-upload-slider']}>
                <InputWithMovingLabel
                    label={typeData.label}
                    errorMessage={error}
                    labelOnTop={true}
                    holderClass={`${error ? styles['has-error'] : ''} ${styles['input-holder']}`}
                    input={{
                        value,
                        as: 'textarea',
                        className: styles['link-input'],
                        placeHolder: typeData.placeHolder,
                        onChange: handleChange,
                        autoFocus: true
                    }}
                    inputGroupProps={{
                        rightIconClass: value ? `icon-HDRcross ${styles['cross-icon']}` : null,
                        onRightIconClick: clearValue,
                        rightSection: () => {
                            if(value || !navigator.clipboard || deviceData?.isIphone || deviceData?.isIphoneApp) {
                                return null;
                            }

                            return (
                                <AnimateOnHover
                                    className={styles['paste-btn']}
                                    onClick={onPasteClick}
                                >Paste</AnimateOnHover>
                            )
                        }
                    }}
                />
                {isMobile ? <Button
                    {...btnPropsObj}
                /> : null}
            </div>
        </SliderWrapper>
    );
};

export default LinkUploadSlider;